import React from "react";
import '../styles/FeedbackForm.css';

const FeedbackForm = ({ feedbackDescription, setFeedbackDescription, handleFeedbackSubmit, disabled }) => {
    return (
        <div className="feedback-section">
            
            {disabled && <p className="feedback-warning">Please select a video to which you want to give feedback from the dropdown.</p>}
            
            <h1 className="feedback-heading">Feedback Form</h1>
            
            <textarea
                className="feedback-textarea"
                placeholder="Write your feedback here..."
                value={feedbackDescription}
                onChange={(e) => setFeedbackDescription(e.target.value)}
                disabled={disabled}
            />

            <button
                className="feedback-publish-button"
                onClick={handleFeedbackSubmit}
                disabled={disabled}
            >
                Publish
            </button>
        </div>
    );
};

export default FeedbackForm;
